<template>
    <el-dialog-menu :visible.sync="visible" :loading="$store.state.loading" :title="contract.number" :tip="contract.name" @close="Close" fullscreen>
        <template slot="menu">
            <div :style="{ marginBottom: '10px' }">
                <el-alert center :closable="false" v-if="contract.draft" title="此合同未发布（草稿）" type="info" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 0" title="无需审核" type="info" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 1" title="等待审核中" type="warning" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 2" title="正在审核中" type="warning" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 3" title="审核结果：拒绝" type="error" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 4" title="审核通过" type="success" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 5" title="等待撤销中" type="warning" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 6" title="撤销审核中" type="warning" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 7" title="撤销结果：拒绝" type="error" />
                <el-alert center :closable="false" v-if="!contract.draft && contract.workflow_state == 8" title="撤销结果：同意" type="success" />
            </div>
            <div :style="{ marginBottom: '10px', display: 'grid', gap: '5px', gridTemplateColumns: 'repeat(1, 1fr)' }">
                <el-button :style="{ margin: '0px' }" icon="el-icon-folder-checked" type="primary" @click="$refs.projectsCreate.open({ contract_id: contract.id })">创建关联项目</el-button>
            </div>
            <el-dialog-menu-group title="合同信息">
                <el-dialog-menu-item
                    title="合同概况"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-base'"
                    @onClick="currentComponent = 'crm-contract-drawer-base'" />
                <el-dialog-menu-item
                    title="合同描述"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-describe'"
                    @onClick="currentComponent = 'crm-contract-drawer-describe'" />
                <el-dialog-menu-item
                    title="回访记录"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-visit'"
                    @onClick="currentComponent = 'crm-contract-drawer-visit'" />
                <el-dialog-menu-item
                    title="附件"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-files'"
                    @onClick="currentComponent = 'crm-contract-drawer-files'" />
            </el-dialog-menu-group>
            <el-dialog-menu-group title="采购信息">
                <el-dialog-menu-item
                    title="采购单"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-ims-order'"
                    @onClick="currentComponent = 'crm-contract-drawer-ims-order'" />
            </el-dialog-menu-group>
            <el-dialog-menu-group title="合同款项">
                <el-dialog-menu-item
                    title="回款计划"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-pay-plan'"
                    @onClick="currentComponent = 'crm-contract-drawer-pay-plan'" />
                <el-dialog-menu-item
                    title="回款记录"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-pay-record-enter'"
                    @onClick="currentComponent = 'crm-contract-drawer-pay-record-enter'" />
                <el-dialog-menu-item
                    title="退款记录"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-pay-record-out'"
                    @onClick="currentComponent = 'crm-contract-drawer-pay-record-out'" />
                <el-dialog-menu-item
                    title="开票信息"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-pay-invoice'"
                    @onClick="currentComponent = 'crm-contract-drawer-pay-invoice'" />
            </el-dialog-menu-group>
            <el-dialog-menu-group title="合同日志">
                <el-dialog-menu-item
                    title="操作记录"
                    icon="el-icon-data-analysis"
                    :is-active="currentComponent == 'crm-contract-drawer-log'"
                    @onClick="currentComponent = 'crm-contract-drawer-log'" />
            </el-dialog-menu-group>
        </template>
        <template slot="footer">
            <el-dialog-menu-item icon="el-icon-refresh" title=" 刷新" @onClick="RePage()" />
            <el-dialog-menu-item icon="el-icon-edit" title=" 编辑" @onClick="$refs.contractUpdate.open(contract.id)" />
            <el-dialog-menu-item icon="el-icon-delete" title=" 删除" @onClick="ContractDelete()" />
        </template>
        <component :is="currentComponent" :contract_id="contract.id" :customer_id="contract.customer_id" />
        <contract-update ref='contractUpdate' @onSave="RePage" />
        <pm-projects-create ref="projectsCreate" @success="RePage" />
    </el-dialog-menu>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            currentComponent: 'crm-contract-drawer-base',
            contractFile: [],
            contract: {
                id: null,
                source: [],
                customer: {},
                project: {},
                time_limit: [],
                user_admin: {},
                user_affair: {},
                user_presale: {},
                user_sale: {},
                files_id: []
            }
        }
    },
    methods: {
        Open(id) {
            this.ContractGet(id, true)
        },
        Close () {
            this.currentComponent ='crm-contract-drawer-base'
            this.$emit('onChange')
            this.visible = false
        },
        ContractGet(id = this.contract.id, openOnSuccess = false) {
            this.$http.post(
                '/9api/crm/contract/search-first',
                {
                    id: id,
                    append: ['customer', 'user_sale', 'user_admin', 'user_affair', 'user_presale', 'source', 'team_read', 'project', 'sale_documentary','product_order'],
                    hidden: ['describe']
                }
            ).then(rps => {
                this.contract = rps.data
                if (openOnSuccess) {
                    this.currentComponent = 'crm-contract-drawer-base'
                    this.visible = true
                }
            })
        },
        RePage() {
            this.ContractGet()
            this.$refs.dialogApprove.Update()
            this.$refs.notification.Load()
        },
        ContractDelete() {
            this.$http.post('/9api/contract/delete', {id: this.contract.id}).then(rps => {
                if (rps.data.state == 'success' ) {
                    this.visible = false
                }
            })
        },
    }
}
</script>6
